// import React from "react";
// import { Navigate } from "react-router-dom";
// import { useSelector } from "react-redux";

// /**
//  * A wrapper for route-level permission checking
//  * @param {JSX.Element} children - Component to render
//  * @param {string[]} requiredPermissions - List of required permissions
//  */
// const PermissionRoute = ({ children, requiredPermissions }) => {
//     const { permissions } = useSelector((state) => state.auth);

//     // Make sure permissions[0] exists and has a `permissions` array
//     const userPermissions = permissions?.[0]?.name || [];

//     const hasPermission = requiredPermissions.some((perm) =>
//         userPermissions.includes(perm)
//     );


//     if (!hasPermission) {
//         return <Navigate to="/unauthorized" replace />;
//     }

//     return children;
// };

// export default PermissionRoute;





// import React, { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
// import { useSelector } from "react-redux";

// /**
//  * A wrapper for route-level permission checking
//  * @param {JSX.Element} children - Component to render
//  * @param {string[]} requiredPermissions - List of required permissions
//  */
// const PermissionRoute = ({ children, requiredPermissions }) => {
//     const { permissions } = useSelector((state) => state.auth);

//     const userPermissions = permissions?.[0]?.name || [];

//     const [shouldRedirect, setShouldRedirect] = useState(false);

//     const hasPermission = requiredPermissions.some((perm) =>
//         userPermissions.includes(perm)
//     );

//     useEffect(() => {
//         if (!hasPermission) {
//             alert("You do not have permission to access this page.");
//             setShouldRedirect(true);
//         }
//     }, [hasPermission]);

//     if (shouldRedirect) {
//         return <Navigate to="/unauthorized" replace />;
//     }

//     return children;
// };

// export default PermissionRoute;

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

// Recursively extract permission names from nested structure
// const extractPermissionNames = (nodes = []) => {
//   let result = [];

//   for (const node of nodes) {
//     if (node.name) result.push(node.name);
//     if (node.children?.length) {
//       result = result.concat(extractPermissionNames(node.children));
//     }
//   }

//   return result;
// };
// Returns all permission paths like: "Access Management > Permission Management > Create"
const extractPermissionPaths = (nodes = [], currentPath = "") => {
  let result = [];

  for (const node of nodes) {
    const newPath = currentPath ? `${currentPath} > ${node.name}` : node.name;
    result.push(newPath);

    if (node.children?.length) {
      result = result.concat(extractPermissionPaths(node.children, newPath));
    }
  }

  return result;
};

// const PermissionRoute = ({ children, requiredPermissions }) => {
//   const { permissions } = useSelector((state) => state.auth);

//   const userPermissionNames = extractPermissionNames(permissions);

//   const [shouldRedirect, setShouldRedirect] = useState(false);

//   const hasPermission = requiredPermissions.some((perm) =>
//     userPermissionNames.includes(perm)
//   );


//   useEffect(() => {
//     if (!hasPermission) {
//       alert("You do not have permission to access this page.");
//       setShouldRedirect(true);
//     }
//   }, [hasPermission]);

//   if (shouldRedirect) {
//     return <Navigate to="/unauthorized" replace />;
//   }

//   return children;
// };
const PermissionRoute = ({ children, requiredPermissions }) => {
  const { permissions } = useSelector((state) => state.auth);

  const userPermissionPaths = extractPermissionPaths(permissions);

  const [shouldRedirect, setShouldRedirect] = useState(false);

  const hasPermission = requiredPermissions.some((requiredPath) =>
    userPermissionPaths.includes(requiredPath)
  );

  useEffect(() => {
    if (!hasPermission) {
      alert("You do not have permission to access this page.");
      setShouldRedirect(true);
    }
  }, [hasPermission]);

  if (shouldRedirect) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default PermissionRoute;

